import React, { useState } from "react";
import { Container, Heading } from "./style"; // Import styled components
import NsfdcFilters from "./filters.js"; // Filters component
import NsfdcTable from "./Table.js";
import { Input } from "antd";

const { Search } = Input;

const NsfdcSchemesWinners = () => {
  const [winnersData, setWinnersData] = useState([]); // Store the data for the winners table
  const [filteredData, setFilteredData] = useState([]); // Store filtered data for search

  // Handle data fetched from filters and update the table
  const handleWinnersViewed = (data) => {
    const updatedData = data.map((winner) => ({
      ...winner,
      caste: winner.caste.toUpperCase(), // Convert caste name to uppercase
    }));
    setWinnersData(updatedData);
    setFilteredData(updatedData); // Set initial filtered data
  };

  // Handle search by applicant name or ID
  const handleSearch = (value) => {
    if (!value) {
      setFilteredData(winnersData); // Reset to full data if search is cleared
      return;
    }

    const lowerCasedValue = value.toLowerCase();
    const filtered = winnersData.filter(
      (winner) =>
        winner.name.toLowerCase().includes(lowerCasedValue) ||
        winner.id.toString().includes(lowerCasedValue)
    );

    setFilteredData(filtered);
  };

  return (
    <Container>
      <Heading>
        <h1>View Winners List</h1>
        <p>Select Scheme, Category, and District to view the winners.</p>
      </Heading>

      {/* Filters Component */}
      <NsfdcFilters
        onResultsFetched={() => console.log("Winners selected!")} // Callback for logging
        onWinnersViewed={handleWinnersViewed} // Pass data to the parent
      />

      {/* Search Bar */}
      <Search
        placeholder="Search by Applicant Name or ID"
        allowClear
        enterButton="Search"
        style={{ marginBottom: "20px", marginTop: "20px", width: "42.5%" }}
        onSearch={handleSearch} // Handle search input
      />

      {/* Winners Table Component */}
      <NsfdcTable
        data={filteredData} // Pass the data to the table
      />
    </Container>
  );
};

export { NsfdcSchemesWinners };
